import React, { ReactNode } from 'react';

import { Row } from './DataCard.styled';

interface IProps {
  children: ReactNode;
}

export const DataCardRow = ({ children }: IProps) => {
  return <Row>{children}</Row>;
};
